/* tslint:disable */
/* eslint-disable */
/**
 * Sports App Training Plans
 * API for the Sports App Training Plans
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MuscleTag
 */
export interface MuscleTag {
    /**
     * 
     * @type {string}
     * @memberof MuscleTag
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof MuscleTag
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof MuscleTag
     */
    imageId?: string;
    /**
     * 
     * @type {string}
     * @memberof MuscleTag
     */
    description?: string;
    /**
     * 
     * @type {string}
     * @memberof MuscleTag
     */
    exemplaryExerciseId?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof MuscleTag
     */
    connectedBoneIds?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof MuscleTag
     */
    groupMuscleTagIds?: Array<string>;
}

/**
 * Check if a given object implements the MuscleTag interface.
 */
export function instanceOfMuscleTag(value: object): value is MuscleTag {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    return true;
}

export function MuscleTagFromJSON(json: any): MuscleTag {
    return MuscleTagFromJSONTyped(json, false);
}

export function MuscleTagFromJSONTyped(json: any, ignoreDiscriminator: boolean): MuscleTag {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'imageId': json['imageId'] == null ? undefined : json['imageId'],
        'description': json['description'] == null ? undefined : json['description'],
        'exemplaryExerciseId': json['exemplaryExerciseId'] == null ? undefined : json['exemplaryExerciseId'],
        'connectedBoneIds': json['connectedBoneIds'] == null ? undefined : json['connectedBoneIds'],
        'groupMuscleTagIds': json['groupMuscleTagIds'] == null ? undefined : json['groupMuscleTagIds'],
    };
}

export function MuscleTagToJSON(json: any): MuscleTag {
    return MuscleTagToJSONTyped(json, false);
}

export function MuscleTagToJSONTyped(value?: MuscleTag | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'imageId': value['imageId'],
        'description': value['description'],
        'exemplaryExerciseId': value['exemplaryExerciseId'],
        'connectedBoneIds': value['connectedBoneIds'],
        'groupMuscleTagIds': value['groupMuscleTagIds'],
    };
}

